import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "el-icon el-icon-check fas"
}
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-eye fas" }, null, -1)

import { Pagination } from "@/types/pagination.type";
import { ImageLossAlert } from "@/types/issueMonitoring.type.ts";
import { computed, ref, watch } from "vue";
import { ElRowClassNameParams } from "@/types/element.type";
import { putImageLossAlert } from "@/service/imagelossalert.service.ts";
import { getIssueDiagnosis } from "@/service/issueDiagnosis.service.ts";
import issueFormEditComponent from "@/components/issueMonitoring/issueFormEdit.component";
import { Filter } from "@/types/filter.type";
import { IssueDiagnosis } from "@/types/issueMonitoring.type";
import { Check, Close } from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    pagination: null
  },
  emits: ["changeSize", "changePage"],
  setup(__props: any, { emit }: { emit: ({
  (e: "changeSize", size: number): void;
  (e: "changePage", page: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pagination: Pagination<ImageLossAlert> | null;
}


const currentPage = ref(props.pagination?.currentPage || 1);
const points = computed(() => props.pagination.data || []);
// editIssue
const dialogTableVisible = ref(false);

const selectedIssue = ref<ImageLossAlert>({} as ImageLossAlert);
const issueDiagnosis = ref<IssueDiagnosis | null>({} as IssueDiagnosis);

// - emit


const options = [
  {
    value: "REVIEWED",
    label: "Revisado",
    icon: Check,
  },
  {
    value: null,
    label: "Sin revisar",
  },
];

const tableRowClassName = (params: ElRowClassNameParams<ImageLossAlert>) => {
  let classRow = "";
  if (params.row && params.row.origin === "AUTOMATIC") {
    classRow = "row-automatic";
  }

  // Incidencia desactivada
  if (!params.row.status) {
    classRow += " row-gray";
  }
  return classRow;
};

const updateStatusOperation = async (entity: ImageLossAlert) => {
  await putImageLossAlert(entity as ImageLossAlert);
};

const goToSeeMore = async (entity: ImageLossAlert) => {
  const filter: Filter = {
    fields: {
      "imageLossAlert.id": { operator: "equal", value: entity.id },
    },
  };

  issueDiagnosis.value = (await getIssueDiagnosis(undefined, undefined, filter)).data[0];

  selectedIssue.value = entity;
  dialogTableVisible.value = true;
};

const closeAddIssue = () => {
  selectedIssue.value = {};
  issueDiagnosis.value = null;
  dialogTableVisible.value = false;
};

//- WATCH
watch(
  () => props.pagination,
  (newVal) => {
    // - change currentPage
    currentPage.value = newVal?.currentPage || 1;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_table, {
        data: _unref(points),
        style: {"width":"100%"},
        "row-class-name": tableRowClassName,
        height: "calc(100vh - 300px)"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "code",
            label: _ctx.$t('label.issueId'),
            width: "120"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "samplingPoint.name",
            label: _ctx.$t('label.name'),
            width: "250"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "camera",
            label: _ctx.$t('label.camera'),
            width: "80"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('label.startDate'),
            width: "150"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.fromDateTime
              ? _ctx.$d(new Date(scope.row.fromDateTime.toLocaleString()), "dateTimeNoSecs").replace(
                  ",",
                  ""
                )
              : "-"), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('label.endDateTime'),
            width: "150"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.toDateTime
              ? _ctx.$d(new Date(scope.row.toDateTime.toLocaleString()), "dateTimeNoSecs").replace(
                  ",",
                  ""
                )
              : "-"), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('label.issueDescription'),
            width: "400"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.type?.name ? scope.row.type?.name : "-") + " " + _toDisplayString(scope.row.subtype?.name), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('label.statusOperation'),
            width: "170"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_select, {
                modelValue: scope.row.statusIssue,
                "onUpdate:modelValue": ($event: any) => ((scope.row.statusIssue) = $event),
                onChange: ($event: any) => (updateStatusOperation(scope.row))
              }, {
                prefix: _withCtx(() => [
                  (scope.row.statusIssue === 'REVIEWED')
                    ? (_openBlock(), _createElementBlock("em", _hoisted_1))
                    : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Close))
                        ]),
                        _: 1
                      }))
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("span", null, _toDisplayString(item.label), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "value"])
                  }), 64))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('label.operations')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "dark",
                content: _ctx.$t('btn.showMore'),
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    onClick: ($event: any) => (goToSeeMore(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_pagination, {
        class: "app-table",
        layout: "total, sizes, prev, pager, next, jumper",
        currentPage: currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        "page-sizes": [10, 20, 50, 100],
        "page-size": __props.pagination?.rowPerPage,
        total: __props.pagination?.totalRows,
        onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (emit('changeSize', $event))),
        onCurrentChange: _cache[2] || (_cache[2] = ($event: any) => (emit('changePage', $event)))
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogTableVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogTableVisible).value = $event)),
      title: _ctx.$t('title.infoIssue'),
      width: "80%"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_unref(issueFormEditComponent), {
          key: selectedIssue.value?.id,
          issue: selectedIssue.value,
          diagnosis: issueDiagnosis.value,
          onClose: closeAddIssue,
          onGetIssue: _ctx.addIssue,
          ref: "issueFormEdit"
        }, null, 8, ["issue", "diagnosis", "onGetIssue"]))
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})